
import { Component, Prop } from "vue-property-decorator";
import {
  EpgItem,
  Movie,
  Promotion,
  TvShow
} from "@/services/apiService/api.types";
import apiStorageInterface from "@/services/apiStorageInterface";
import Swiper, { SwiperOptions } from "swiper";
import { LocaleHomeString } from "@/plugins/i18n/types";
import Player from "@/components/player/components/Player.vue";
import { arrowKeysPreventDefault, isMovie, isTvShow } from "@/helpers/utils";
import { Action, Getter, Mutation } from "vuex-class";
import { HomePageGetter, HomePageMutation } from "@/components/homePage/types";
import { Namespace } from "@/store/types";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import SpatialNavigation from "spatial-navigation-js";
import { RouteName } from "@/router/types";
import {
  ChannelChangeAction,
  ChannelChangeMutation
} from "@/components/channelChange/types";
import { ChannelEpgParams, OverlayAction } from "@/components/overlay/types";
import { VodPageMutation } from "@/components/VoD/types";
import {
  ChannelsPageMutation,
  InfoChannelData
} from "@/components/channelsPage/types";
import { mixins } from "vue-class-component";
import { EpgHelpers } from "@/mixins/EpgHelpers";

@Component({
  components: { Player }
})
export default class Promotions extends mixins(EpgHelpers) {
  @Prop() readonly activeSlideIndex!: number;

  @Action(ChannelChangeAction.UpdateSource, {
    namespace: Namespace.ChannelChange
  })
  updateSource!: (src: string) => void;

  @Action(ChannelChangeAction.UpdateOffset, {
    namespace: Namespace.ChannelChange
  })
  updateOffset!: (offset: number) => void;

  @Action(OverlayAction.UpdateChannelEpg, {
    namespace: Namespace.Overlay
  })
  updateChannelEpg!: (channelEpgParams?: ChannelEpgParams) => Promise<void>;

  @Mutation(HomePageMutation.setPromotionKeyControl, {
    namespace: Namespace.HomePage
  })
  setPromotionKeyControl!: (status: boolean) => void;

  @Mutation(ChannelChangeMutation.SetChannelId, {
    namespace: Namespace.ChannelChange
  })
  setChannelId!: (channelId: number) => void;

  @Mutation(VodPageMutation.SetPromoVod, {
    namespace: Namespace.Vod
  })
  setPromoVod!: (promoVoD: Movie | TvShow | null) => void;

  @Mutation(ChannelsPageMutation.setActiveChannelOverlayInfo, {
    namespace: Namespace.ChannelsPage
  })
  setActiveChannelOverlayInfo!: (channelInfo?: InfoChannelData) => void;

  @Mutation(ChannelsPageMutation.setShowInfoScreen, {
    namespace: Namespace.ChannelsPage
  })
  setShowInfoScreen!: (showInfoScreen: boolean) => void;

  @Mutation(ChannelsPageMutation.setActiveInfoScreenEpgItem, {
    namespace: Namespace.ChannelsPage
  })
  setActiveInfoScreenEpgItem!: (epgItem?: EpgItem) => void;

  @Getter(HomePageGetter.GetPromotionKeyControl, {
    namespace: Namespace.HomePage
  })
  getPromotionKeyControl!: boolean;

  promotions: Promotion[] = [];

  swiperOptions: SwiperOptions = {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  };

  LocaleHomeString = LocaleHomeString;

  promotionsSwiper: Swiper | undefined;

  swiperActiveIndex = 0;

  async mounted(): Promise<void> {
    this.promotions = await apiStorageInterface.fetchPromotions();
    this.$nextTick(() => {
      this.promotionsSwiper = new Swiper("#swiperPromo", this.swiperOptions);

      if (this.getPromotionKeyControl) {
        SpatialNavigation.focus("#liveHeading");
        this.setPromotionKeyControl(false);
      }

      if (this.promotions[this.promotionsSwiper.activeIndex].channel)
        this.playChannel(this.promotionsSwiper.activeIndex);

      this.promotionsSwiper.on("slideChange", (promoSwiper) => {
        if (this.promotions[promoSwiper.activeIndex].channel)
          this.playChannel(promoSwiper.activeIndex);

        this.swiperActiveIndex = this.promotionsSwiper
          ? this.promotionsSwiper?.activeIndex
          : 0;
      });
    });
  }

  handlePromotionActions(event: KeyboardEvent): void {
    arrowKeysPreventDefault(event);
    if (this.getPromotionKeyControl) {
      switch (keyCodeFinder(event.keyCode)) {
        case KeySet.KEY_RIGHT:
          if (
            document.activeElement?.classList.contains("swiper-button-prev")
          ) {
            if (
              this.promotionsSwiper &&
              this.getActiveSlideWatchBtn(this.promotionsSwiper.activeIndex)
            ) {
              SpatialNavigation.focus(
                "#watchNowBtn" + this.promotionsSwiper.activeIndex
              );
              return;
            }
            SpatialNavigation.focus(".swiper-button-next");
            return;
          }
          if (
            document.activeElement?.classList.contains(
              "section__promotions__watchBtn"
            )
          ) {
            SpatialNavigation.focus(".swiper-button-next");
          }
          break;
        case KeySet.KEY_LEFT:
          if (
            document.activeElement?.classList.contains("swiper-button-next")
          ) {
            if (
              this.promotionsSwiper &&
              this.getActiveSlideWatchBtn(this.promotionsSwiper.activeIndex)
            ) {
              SpatialNavigation.focus(
                "#watchNowBtn" + this.promotionsSwiper.activeIndex
              );
              return;
            }
            SpatialNavigation.focus(".swiper-button-prev");
            return;
          }
          if (
            document.activeElement?.classList.contains(
              "section__promotions__watchBtn"
            )
          ) {
            SpatialNavigation.focus(".swiper-button-prev");
          }
          break;
        case KeySet.KEY_DOWN:
          SpatialNavigation.focus("#id" + this.activeSlideIndex);
          this.setPromotionKeyControl(false);
          event.stopImmediatePropagation();
          break;
        case KeySet.KEY_ENTER:
          if (
            document.activeElement?.classList.contains("swiper-button-next")
          ) {
            this.promotionsSwiper?.slideNext();
            return;
          }
          if (
            document.activeElement?.classList.contains("swiper-button-prev")
          ) {
            this.promotionsSwiper?.slidePrev();
            return;
          }
          if (
            document.activeElement?.classList.contains(
              "section__promotions__watchBtn"
            )
          ) {
            this.playContent();
          }
          break;
      }
    }
  }

  get imgPlaceholder(): string {
    return require("/src/assets/images/square-image-placeholder.jpg");
  }

  getPromoPoster(promotion: Promotion): string | null {
    if (promotion.media !== null) {
      return promotion.media.url;
    }

    if (promotion.channel !== null) {
      return promotion.channel.media.url;
    }

    if (promotion.tvShow !== null) {
      return promotion.tvShow.media?.url ? promotion.tvShow.media?.url : null;
    }

    if (promotion.movie !== null) {
      return promotion.movie.media?.url ? promotion.movie.media?.url : null;
    }

    return null;
  }

  getPromoVideoContent(promotion: Promotion): string | null {
    if (promotion.tvShow !== null) {
      return promotion.tvShow.trailer?.url
        ? promotion.tvShow.trailer?.url
        : null;
    }

    if (promotion.movie !== null) {
      return promotion.movie.trailer?.url ? promotion.movie.trailer?.url : null;
    }

    if (promotion.channel !== null) {
      return "";
    }

    return null;
  }

  getActiveSlideWatchBtn(promoIndex: number): boolean {
    const { movie, channel, tvShow } = this.promotions[promoIndex];

    return !!(movie || channel || tvShow);
  }

  async playChannel(slideIndex: number, routeToPlayer = false): Promise<void> {
    if (this.promotions[slideIndex].movie) {
      this.updateSource(
        this.promotions[slideIndex].movie?.trailer?.url as string
      );
    }

    if (this.promotions[slideIndex].tvShow) {
      this.updateSource(
        this.promotions[slideIndex].tvShow?.trailer?.url as string
      );
    }

    if (this.promotions[slideIndex].channel) {
      this.updateSource(
        this.promotions[slideIndex].channel?.videoLive as string
      );
      this.setChannelId(this.promotions[slideIndex].channel?.id as number);
    }

    this.updateOffset(0);
    await this.updateChannelEpg();

    if (routeToPlayer) await this.$router.push({ name: RouteName.Player });
  }

  async playContent(): Promise<void> {
    if (this.promotionsSwiper) {
      if (isMovie(this.promotions[this.promotionsSwiper.activeIndex].movie)) {
        this.setPromoVod(
          this.promotions[this.promotionsSwiper.activeIndex].movie
        );
        await this.$router.push({ name: RouteName.VoD });
      }
      if (isTvShow(this.promotions[this.promotionsSwiper.activeIndex].tvShow)) {
        this.setPromoVod(
          this.promotions[this.promotionsSwiper.activeIndex].tvShow
        );
        await this.$router.push({ name: RouteName.VoD });
      }
      if (this.promotions[this.promotionsSwiper.activeIndex].channel) {
        await this.openChannelModal();
      }
    }
  }

  navAction(direction: "left" | "right"): void {
    switch (direction) {
      case "left":
        SpatialNavigation.focus(".swiper-button-prev");
        break;
      case "right":
        SpatialNavigation.focus(".swiper-button-next");
        break;
    }
  }

  async openChannelModal(): Promise<void> {
    const promoChannel =
      this.promotions[this.promotionsSwiper!.activeIndex].channel;
    //fetching epg list and active item
    const channelEpg = await this.fetchChannelEpg(promoChannel!.id);
    const activeEpgItem = this.updateActiveEpgItem(channelEpg);
    if (promoChannel) {
      const channelInfo: InfoChannelData = {
        channelName: promoChannel.name,
        channelId: promoChannel.id,
        channelCatchup: !!promoChannel.catchup
      };

      this.setActiveChannelOverlayInfo(channelInfo);
      this.setActiveInfoScreenEpgItem(activeEpgItem);
      this.setShowInfoScreen(true);
    }

    await this.$router.push({ name: RouteName.Channels });
  }
}
